// extracted by mini-css-extract-plugin
export var column = "SubMenu-module--column--04fe3";
export var flexWrapper = "SubMenu-module--flex-wrapper--3a352";
export var hasIcon = "SubMenu-module--has-icon--61758";
export var icon = "SubMenu-module--icon--84816";
export var link = "SubMenu-module--link--e23fe";
export var menuInception = "SubMenu-module--menu-inception--37b06";
export var sectionDescription = "SubMenu-module--section-description--0a19b";
export var sectionTitle = "SubMenu-module--section-title--01ca1";
export var splitMenu = "SubMenu-module--split-menu--572dd";
export var subNav = "SubMenu-module--sub-nav--19c1e";
export var tertiaryMenu = "SubMenu-module--tertiary-menu--592d4";
export var titleGroup = "SubMenu-module--title-group--1ccc8";